import moment from 'moment'
import { setDefaultLocale } from 'react-datepicker'

const DEFAULT_DATE_LOCALE = 'en-gb'
const DATE_LOCALE_PREFERENCE_KEY = 'dateLocalePreference'

class DateLocaleService {
  
  static initialize() {
    const locale = this.getDateLocale()
    moment.locale(locale)
    setDefaultLocale(locale)
    return locale
  }
  
  static getDateLocale() {
    const useBrowserLocale = localStorage.getItem(DATE_LOCALE_PREFERENCE_KEY) === 'browser'
    const uiLanguage = localStorage.getItem('i18nextLng')
    const languageCode = uiLanguage ? uiLanguage.split('-')[0] : 'en'
    
    if (useBrowserLocale) {
      return languageCode
    }
    
    // Only use en-za default when UI language is English
    // For other languages (af, es, fr, pt, sw), use their locale directly
    if (languageCode === 'en') {
      return DEFAULT_DATE_LOCALE
    }
    
    return languageCode
  }
  
  static setPreference(useBrowserLocale) {
    const preference = useBrowserLocale ? 'browser' : 'default'
    localStorage.setItem(DATE_LOCALE_PREFERENCE_KEY, preference)
    return this.initialize()
  }
  
  static getCurrentFormat() {
    return moment().format('L')
  }
  
  static isUsingBrowserLocale() {
    return localStorage.getItem(DATE_LOCALE_PREFERENCE_KEY) === 'browser'
  }
}

export default DateLocaleService
